import { useHistory } from "react-router-dom"
import { MentorGroupForm } from "../groups/add/AddMentorGroupCard"

function GroupAddAugmentation({ groupId }: { groupId: number }) {
  const history = useHistory()

  return <MentorGroupForm parentGroupId={groupId} onSave={history.goBack} />
}

export default GroupAddAugmentation
